export const TYPE_ABSTRACT_BASE_COMPONENT = "TYPE_ABSTRACT_BASE_COMPONENT";

// DATA Access Handler
export const TYPE_VOWL_STATIC_LOCAL = "TYPE_VOWL_STATIC_LOCAL";
export const TYPE_DBPEDIA_PROXY = "TYPE_DBPEDIA_PROXY";

// PARSERS
export const TYPE_VOWL_PARSER = "TYPE_VOWL_PARSER";
export const TYPE_SPARQL_PARSER = "TYPE_SPARQL_PARSER";
export const TYPE_REL_FINDER_DAH = "TYPE_REL_FINDER_DAH";
export const TYPE_SIMPLE_PROXY = "TYPE_SIMPLE_PROXY";
export const TYPE_SIMPLE_DIRECT_LOADER = "TYPE_SIMPLE_DIRECT_LOADER";

// MODEL MODELS
export const TYPE_ABSTRACT_MODEL = "TYPE_ABSTRACT_MODEL";
export const TYPE_RESOURCE_RELATION_MODEL = "TYPE_RESOURCE_RELATION_MODEL";
export const TYPE_VERTEX_EDGE_MODEL = "TYPE_VERTEX_EDGE_MODEL";
export const TYPE_NODE_LINK_MODEL = "TYPE_NODE_LINK_MODEL";

// // MAPPERS
export const TYPE_VERTEX_EDGE_MAPPER = "TYPE_VERTEX_EDGE_MAPPER";
export const TYPE_NODE_LINK_MAPPER = "TYPE_NODE_LINK_MAPPER";
